import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";

const ONE_MILLION = 1000000000;
const ONE_THOUSAND = 1000;

const PStatistics = ({ user = {} }) => {
    const params = useParams();

    const [state, setState] = useState({});

    const userInformation = localStorage.getItem('user');

    const getUserStat = async () => {
        let route = '';
        let parameters = '';
        if (user && Object.keys(user).length > 0) {
            route = '/api/statistics';
        } else {
            const url = window.location.href;
            const urlParts = url.split('/');
            parameters = urlParts[urlParts.length - 1].split('?');
            route = userInformation && Object.keys(userInformation).length > 0
                ? '/api/statistics'
                : '/api/unauth-statistics';
        }

        await axios.get(route, {
            params: {
                user: user && Object.keys(user).length > 0
                    ? user.login
                    : parameters[0]
            }
        })
            .then(response => {
                setState(response.data);
            });
    };

    useEffect(() => {
        getUserStat();
    }, [user]);

    return (
        <div className="profile-user-details-container">
            <ul>
                <li>
                    <div className="profile-user-details-heading">
                        {
                            state.post > ONE_MILLION
                                ? parseFloat(state.post / ONE_MILLION).toFixed(1) + 'M'
                                : (
                                    state.post > ONE_THOUSAND
                                        ? parseFloat(state.post / ONE_THOUSAND).toFixed(1) + 'K'
                                        : state.post
                                )
                        }
                    </div>
                    <p>Posts</p>
                </li>
                <li>
                    <div className="profile-user-details-heading">
                        {
                            state.image > ONE_MILLION
                                ? parseFloat(state.image / ONE_MILLION).toFixed(1) + 'M'
                                : (
                                    state.image > ONE_THOUSAND
                                        ? parseFloat(state.image / ONE_THOUSAND).toFixed(1) + 'K'
                                        : state.image
                                )
                        }
                    </div>
                    <p>Photos</p>
                </li>
                <li>
                    <div className="profile-user-details-heading">
                        {
                            state.video > ONE_MILLION
                                ? parseFloat(state.video / ONE_MILLION).toFixed(1) + 'M'
                                : (
                                    state.video > ONE_THOUSAND
                                        ? parseFloat(state.video / ONE_THOUSAND).toFixed(1) + 'K'
                                        : state.video
                                )
                        }
                    </div>
                    <p>Videos</p>
                </li>
                {
                    state.like && state.like >= 0
                        ? <li>
                            <div className="profile-user-details-heading">
                                {
                                    state.like > ONE_MILLION
                                        ? parseFloat(state.like / ONE_MILLION).toFixed(1) + 'M'
                                        : (
                                            state.like > ONE_THOUSAND
                                                ? parseFloat(state.like / ONE_THOUSAND).toFixed(1) + 'K'
                                                : state.like
                                        )
                                }
                            </div>
                            <p>Likes</p>
                        </li>
                        : ''
                }
                {
                    state.follower && state.follower >= 0
                        ? <li>
                            <div className="profile-user-details-heading">
                                {
                                    userInformation && userInformation.login == params.username
                                        ? <Link to="/followers">
                                            {
                                                state.follower > ONE_MILLION
                                                    ? parseFloat(state.follower / ONE_MILLION).toFixed(1) + 'M'
                                                    : (
                                                        state.follower > ONE_THOUSAND
                                                            ? parseFloat(state.follower / ONE_THOUSAND).toFixed(1) + 'K'
                                                            : state.follower
                                                    )
                                            }
                                        </Link>
                                        : (
                                            state.follower > ONE_MILLION
                                                ? parseFloat(state.follower / ONE_MILLION).toFixed(1) + 'M'
                                                : (
                                                    state.follower > ONE_THOUSAND
                                                        ? parseFloat(state.follower / ONE_THOUSAND).toFixed(1) + 'K'
                                                        : state.follower
                                                )
                                        )
                                }
                            </div>
                            <p>Followers</p>
                        </li>
                        : ''
                }
            </ul>
        </div>
    );
};

export default React.memo(PStatistics);